import React, { useState } from "react";
import { Chip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { ISMSFilters } from "./models";
import FilterContainer from "modules/common/components/filters/filterContainer";
import AuthoringFilter from "modules/common/components/filters/authoringFilter";
import AuthoringSearch from "modules/common/components/filters/authoringSearch";

interface ISMSFiltersProps {
    filters: ISMSFilters;
    onChangeFilters: (filters: ISMSFilters) => void;
    onClearFilters: () => void;
}

const SMSFilters: React.FC<ISMSFiltersProps> = ({
    filters,
    onChangeFilters,
    onClearFilters
}) => {
    const [textToSearch, setTextToSearch] = useState("");

    const onApplyFilters = () => {
        onChangeFilters({...filters, textToSearch});
    }

    const onInnerClearFilters = () => {
        setTextToSearch("");
        onClearFilters();
    }

    const getFilterSelection = (): JSX.Element | undefined => {
        if (!filters.textToSearch) return undefined;
    
        return <React.Fragment>
            {
                !!filters.textToSearch &&
                <Chip
                    key="sms-search-text"
                    label={`"${filters.textToSearch}"`}
                    onDelete={onInnerClearFilters}
                    deleteIcon={<CloseIcon />}
                />
            }
        </React.Fragment>;
    }

    return <FilterContainer
        filters={
            <AuthoringFilter
                textToSearch={textToSearch}
                searchTextPlaceholder="Search internal title, publisher or sender"
                onChangeTextToSearch={onApplyFilters}
                onUpdateTextToSearch={e => setTextToSearch(e.target.value)}
            />
        }
        filterCommands={
            <AuthoringSearch
                canSearch={!!textToSearch || !!filters.textToSearch}
                onApplyFilters={onApplyFilters}
                onClearFilters={onInnerClearFilters}
            />
        }
        filterSelection={getFilterSelection()}
    />;
}

export default SMSFilters;